import React, { Fragment } from 'react';
import styled from "styled-components";
import checkboxImg from "../images/checkbox.png"

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
`

const Input = styled.input`
    opacity: 0;
    position: absolute;
    width: 0;
    height: 0;
    padding: 0;

    :checked + span {
        background-position: 0 -282px;
    } 
`

const Span = styled.span`
    background-image: url(${checkboxImg});
    display: inline-block;
    width: 100%;
    padding-left: 40px;
    padding-bottom: 10px;
    height: auto;
    vertical-align: middle;
    background-repeat: no-repeat;
    background-position: 0 0;  
    line-height: 1.4;
    width: 320px;
    white-space: pre-line;

    a {
        text-decoration: underline;
    }

    ${props => props.theme.mediaQueries.medium}{
        font-size: 0.6rem;
        width: 540px;
    }
`

const Error = styled.p`
    color: ${props => props.theme.codanColors.codanErrorRed};
    font-size: 12px; 
`

const LabelledCheckboxValidated = ({ 
    labelText, 
    onChange,
    errors,
    values,
    checkboxKvp,
    getValue,
    ...props 
}) => {

    const handleChange = (event) => {
        onChange(event);
        if (getValue !== undefined) {
            getValue(event)
        }
    }

    const renderChackboxes = (checkboxKvp) => {
         return checkboxKvp.map((value, i) => {
            return (
                <Fragment key={i}>
                    <label name={value.name}>
                        <Input
                            type='checkbox'
                            name={value.name}
                            checked={values[value.name] || false}
                            onChange={handleChange}
                            onClick={value.onClick}
                        />
                        <Span>{value.labelText}</Span>
                    </label>
                    {
                        errors[value.name] && (
                            <Error>{errors[value.name]}</Error>
                        )
                    }
                </Fragment>
            )
         })
    }

    return (
        <Wrapper {...props}>
            {renderChackboxes(checkboxKvp)}            
        </Wrapper>
    )
}

export default LabelledCheckboxValidated